import { AddReviewerPermissionsCardShared } from '@scale/genai-compass-shared/cards/add_reviewer_permissions';
import { makeAutoOpsCardUI } from '../constants';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';

export const AddReviewerPermissionsCardUI = makeAutoOpsCardUI(AddReviewerPermissionsCardShared, {
  button: { icon: faUserPlus },
  ownerTeam: 'Allocation',
});
